export default {
  maxDepth: 1040,
  minDepth: 300,
};
